import { z } from 'zod';

import { BasePType } from './base';

export const BreadcrumbItem = BasePType.extend({
  type: z.enum(['breadcrumbItem']),
  linkTitle: z.string(),
  linkUrl: z.string(),
});

export const Breadcrumbs = BasePType.extend({
  type: z.enum(['breadcrumbs']),
  hideHome: z.boolean(),
  nestedBreadcrumbItem: z.array(BreadcrumbItem),
});

export type Breadcrumbs = z.infer<typeof Breadcrumbs>;
export type BreadcrumbItem = z.infer<typeof BreadcrumbItem>;
